<template>
  <div class="personal-info">
      <div class="avin">
        <div class="avatar">
          <a-avatar
            :src="avatarUrl"
            :size="64"
          />
        </div>
        <div class="info">
          <div class="num">编号：{{data.num}}</div>
          <div class="cein">
            <div class="row">
              <span class="cell">
                <span class="title">姓名：</span>
                <span class="value">{{data.name}}</span>
              </span>
              <a-divider type="vertical" />
              <span class="cell">
                <span class="title">所属{{sceneLang.public.school}}：</span>
                <span class="value">{{currentSchool.name}}</span>
              </span>
            </div>
            <div class="row">
              <span class="cell">
                <span class="title">班级：</span>
                <span class="value">{{data.group}}</span>
              </span>
              <a-divider type="vertical" />
              <span class="cell" v-if="appScene!=='unit'">
                <span class="title">班级学号：</span>
                <span class="value">{{data.group_member_num}}</span>
              </span>
            </div>
            <div class="row">
              <span class="cell">
                <span class="title">状态：</span>
                <span class="value fgreen" :class="{fred:data.state=='unbind',fgreen:data.state=='bound'}">{{userState}}</span>
              </span>
              <a-divider type="vertical" />
              <span class="cell">
                <span class="title">联系方式：</span>
                <span class="value">{{data.contact_mobile}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="basic">
        <div class="info">
          <div class="item">
            <div class="icon"><img src="~@/assets/images/icon-cake.png" /></div>
            <div class="text">年龄：{{userAge}}岁</div>
          </div>
          <div class="item">
            <div class="icon"><img src="~@/assets/images/icon-height.png" /></div>
            <div class="text">身高：{{data.height}}cm</div>
          </div>
          <div class="item">
            <div class="icon"><img src="~@/assets/images/icon-weight.png" /></div>
            <div class="text">体重：{{data.weight}}kg</div>
          </div>
          <div class="item">
            <div class="icon"><img src="~@/assets/images/icon-sports.png" /></div>
            <div class="text">运动频率：{{sportFreq}}</div>
          </div>
        </div>
        <div class="bmi">
          <div class="bminum">
            <div class="item">
              <div class="title"></div>
              <div class="value"><b></b></div>
            </div>
            <div class="item">
              <div class="title">BMI值：</div>
              <div class="value"><b>{{BMI.value}}</b>{{BMI.des}}</div>
            </div>
          </div>
          <div class="chart">
            <div
              ref="bmiChartDiv"
              class="icon"
              style="left:60%;"
            ><img src="~@/assets/images/emoji-good.png" /></div>
            <div class="progress">
              <div class="item">
                <div class="pro"></div>
                <div class="text">偏瘦<br>&lt;{{bmiBorders[0]}}</div>
              </div>
              <div class="item">
                <div class="pro"></div>
                <div class="text">正常<br>&lt;{{bmiBorders[0]}}~{{bmiBorders[1]}}</div>
              </div>
              <div class="item">
                <div class="pro"></div>
                <div class="text">超重<br>&lt;{{bmiBorders[1]}}~{{bmiBorders[2]}}</div>
              </div>
              <div class="item">
                <div class="pro"></div>
                <div class="text">肥胖<br>&gt;{{bmiBorders[2]}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import apis from '@/business/apis'
import { bindStates } from '@/business/enums'
import avatarUrl from '@/assets/images/default-avatar.jpg'
import { getCommonBMIRange, getBmiBorders } from '../../../utils/childStd'
export default {
  data () {
    return {
      avatarUrl,
      data: {},
      bmiBorders2: []
    }
  },
  computed: {
    ...mapState('school', [
      'currentSchool'
    ]),
    userAge () {
      if (!this.data || !this.data.birthday) return 0
      const now = moment()
      return now.diff(moment(this.data.birthday), 'years')
    },
    age () {
      if (!this.data || !this.data.birthday) return 0
      let age = moment().diff(moment(this.data.birthday), 'years', true)
      const ageInt = parseInt(age)
      if (age < 18 && age - ageInt >= 0.5) {
        age = ageInt + 0.5
      } else {
        age = ageInt
      }
      return age
    },
    userState () {
      return bindStates[this.data.state]
    },
    bmiBorders: function () {
      const age = this.age
      const sex = this.data.gender === '女' ? 2 : 1
      if (this.data.birthday && age < 7) {
        return getCommonBMIRange(sex, this.data.birthday, moment())
      }
      return getBmiBorders(sex, age)
    },
    BMI () {
      if (!this.data.height || !this.data.weight) {
        return { value: 0, des: '' }
      }
      const value = this.data.weight / (this.data.height * this.data.height * 0.0001)
      if (value < this.bmiBorders[0]) {
        return { value: value.toFixed(2), des: '偏瘦' }
      }
      if (value >= this.bmiBorders[0] && value < this.bmiBorders[1]) {
        return { value: value.toFixed(2), des: '正常' }
      }
      if (value >= this.bmiBorders[1] && value < this.bmiBorders[2]) {
        return { value: value.toFixed(2), des: '超重' }
      }
      return { value: value.toFixed(2), des: '肥胖' }
    },
    sportFreq () {
      switch (this.data.sport_freq) {
        case 1:
          return '基本不运动'
        case 2:
          return '少量运动'
        case 3:
          return '中等量运动'
        case 4:
          return '大量运动'
        case 5:
          return '超大量运动'
      }
      return ''
    }
  },
  methods: {
    async loadData () {
      if (!this.$route.params || !this.$route.params.userId) return
      const response = await this.$http.get(apis.user.detail + this.$route.params.userId)
      this.data = response.body.user || {}
      this.setBmiDivStyle()
    },
    setBmiDivStyle () {
      if (!this.$refs.bmiChartDiv) return
      const value = this.BMI.value
      let left = 0
      if (value < this.bmiBorders[0]) {
        left = 0.25 * value / this.bmiBorders[0]
      } else if (value >= this.bmiBorders[0] && value < this.bmiBorders[1]) {
        left = 0.25 + 0.25 * (value - this.bmiBorders[0]) / 5.5
      } else if (value >= this.bmiBorders[1] && value < this.bmiBorders[2]) {
        left = 0.5 + 0.25 * (value - this.bmiBorders[1]) / 4
      } else {
        left = 0.75 + 0.25 * (value - this.bmiBorders[2]) / 10
        left = left > 1 ? 1 : left
      }
      this.$refs.bmiChartDiv.style.left = (left * 100).toFixed(1) + '%'
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>
